export const standardLineWidth = 4
